import ApolloClient from 'apollo-boost'
import fetch from 'isomorphic-fetch';

export const client = new ApolloClient({
  uri: 'https://graphql.fauna.com/graphql',
  fetch,
  request: (operation) => {
    const token = process.env.FAUNA_SECRET
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })
  }
});
